<form [formGroup]="form" appFormErrorScroll (ngSubmit)="submit()">
  <div class="row">
    <!-- Address form component -->
    <div class="col-12">
      <app-address-input formControlName="address" [hideCountryField]="false"></app-address-input>
    </div>

    <!-- Category select -->
    <div class="col-12 col-md-6">
      <mat-form-field>
        <mat-label>Portfolio</mat-label>
        <mat-select id="onBoardingPropertyCategorySelect"
          formControlName="category"
          placeholder="Select Category"
          required>
          @for (category of categories; track category) {
            <mat-option
            [value]="category">{{category.name}}</mat-option>
          }
        </mat-select>

        <div matSuffix>
          <ng-container [appPreloader]="[endpoints.PROPERTIES_CATEGORIES_GET]"
            [preloaderType]="preloaderTypes.ICON"
            [preloaderSize]="20">
          </ng-container>
        </div>

        @if (form.get('category').invalid) {
          <mat-error>
            <app-validation-error [errors]="form.get('category').errors"></app-validation-error>
          </mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Property Share -->
    <div class="col-12 col-md-6">
      <app-property-share-form [form]="form.get('share')" [isTransparent]="true"></app-property-share-form>
    </div>

    <!-- Purchase price input -->
    <div class="col-12">
      <app-currency-input min="0"
                          inputId="onBoardingPropertyPurchaseAdd"
                          formControlName="purchasePrice"
                          tooltip="Enter the purchase price in AUD.
                           If the investment was purchased in a foreign currency, convert the amount to AUD using the exchange rate at the time."
                          label="Purchase Price, AUD"
                          placeholder="Enter Purchase Price">
      </app-currency-input>
    </div>

    <!-- Purchase date datepicker -->
    <div class="col-12 col-md-6">
      <app-datepicker label="Contract Date" [max]="now" formControlName="contractDate"></app-datepicker>
    </div>

    <!-- Settlement date datepicker -->
    <div class="col-12 col-md-6">
      <app-datepicker label="Settlement Date" formControlName="settlementDate"></app-datepicker>
    </div>

    <!-- Forecast form -->
    <div class="col-12">
      <h6 class="mb-15">
        Annual Forecasts (estimations are fine)
        <i class="icon icon-info ic-secondary ml-5" matTooltip="Enter forecast amounts in AUD.
          If the income or expense is expected in a foreign currency, convert it to AUD using the current or estimated exchange rate. An estimate is fine — forecasts can be updated later as needed.">
        </i>
      </h6>
      <!-- [category]="form.categoryMovementForm.get('propertyCategory').value" -->
      <app-property-forecast-form [form]="form.forecastForm"
        [category]="form.get('category').value"
        [isTransparent]="true">
      </app-property-forecast-form>
    </div>
  </div>
</form>
